import Secure from "@/secure/payload";
import { API_URLS } from "@/utils/constant/api.constant";
import { C_API } from "@/utils/helper/api";

export const addRole = async (data: any) => {
  const encryptData = Secure.payloadEncryption(data);
  try {
    const response = await C_API.post(API_URLS.ROLE.ADD, encryptData);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};
export const AssignRole = async (data: any) => {
  const encryptData = Secure.payloadEncryption(data);
  try {
    const response = await C_API.post(API_URLS.ROLE.ASSIGN, encryptData);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};
export const editRole = async (data: any) => {
  const encryptData = Secure.payloadEncryption(data);
  try {
    const response = await C_API.post(API_URLS.ROLE.EDIT, encryptData);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};
export const deleteRole = async (data: any) => {
  const encryptData = Secure.payloadEncryption(data);
  try {
    const response = await C_API.post(API_URLS.ROLE.DELETE, encryptData);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};
import { useQuery } from "@tanstack/react-query";

const fetchUseOrgRoles = async (page?: number, perPage?: number, query?: string) => {
  const params = { page, per_page: perPage, ...(query ? { query } : {}) };
  const res = await C_API.get(`/roles`, { params });
  return res.data?.data;
};

export const useOrgRoles = (perms: { page?: number; perPage?: number; query?: string }) => {
  const { page, perPage, query = "" } = perms || {};
  return useQuery({
    queryKey: ["roles", page, perPage, query],
    queryFn: () => fetchUseOrgRoles(page, perPage, query),
    staleTime: 30 * 1000,
    retry: false,
  });
};
const fetchOrgPermissions = async (page?: number, perPage?: number) => {
  const params = { page, per_page: perPage };
  const res = await C_API.get(`/permissions`, { params });
  return res.data?.data;
};

export const useOrgPermissions = (page?: number, perPage?: number) => {
  return useQuery({
    queryKey: ["roles", page, perPage],
    queryFn: () => fetchOrgPermissions(page, perPage),
    staleTime: 30 * 1000,
    retry: false,
  });
};

export const updatePermission = async (data: any) => {
  try {
    const response = await C_API.post(API_URLS.PERMISSION.UPDATE, data);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};

const fetchOrgRoleUsers = async (roleId: string, { page, perPage, query }: { page?: number; perPage?: number; query?: string }) => {
  const params = { page, per_page: perPage, query };
  const res = await C_API.get(`/user-list/${roleId}`, { params });
  return res.data?.data;
};

export const useOrgRoleUsers = (roleId: string, { page, perPage, query }: { page?: number; perPage?: number; query?: string }) => {
  return useQuery({
    queryKey: ["roles", roleId, page, perPage, query],
    queryFn: () => fetchOrgRoleUsers(roleId, { page, perPage, query }),
    staleTime: 30 * 1000,
    retry: false,
  });
};
